import React from 'react';
export function Privacy() {
  return <div className="py-16 px-4 max-w-4xl mx-auto w-full" data-id="element-303">
      <div className="mb-12 border-b border-neutral-800 pb-8" data-id="element-304">
        <h1 className="font-display text-5xl tracking-wide mb-4" data-id="element-305">
          VSC Clothing Privacy Policy | Last Updated: June 2025
        </h1>
        <p className="text-neutral-300 font-medium" data-id="element-306">
          VSCCLOTHING d/b/a VSC Clothing
        </p>
        <p className="text-neutral-400 mt-1" data-id="element-307">
          312 S 4th Street Downtown, Louisville, KY 40202
        </p>
      </div>

      <div className="prose prose-invert prose-neutral max-w-none space-y-8" data-id="element-308">
        <section data-id="element-309">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-310">
            Information We Collect
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-311">
            We collect information you provide directly to us, such as when you
            create or modify your account, make a purchase, request customer
            support, or communicate with us. This information may include your
            name, email address, phone number, postal address, payment
            information, and other details you choose to provide.
          </p>
        </section>

        <section data-id="element-312">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-313">
            How We Use Your Information
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-314">
            We use the information we collect to fulfill your orders,
            communicate with you about products, services, and promotions, and
            to improve our website and customer service. We may also use your
            information to detect, investigate, and prevent fraudulent
            transactions and other illegal activities.
          </p>
        </section>

        <section data-id="element-315">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-316">
            SMS Communications
          </h2>
          <p className="text-neutral-300 leading-relaxed font-semibold text-vsc-gold" data-id="element-317">
            Phone numbers collected for SMS opt-in will not be shared with third
            parties or affiliates for marketing purposes.
          </p>
          <p className="text-neutral-300 leading-relaxed mt-2" data-id="element-318">
            When you opt-in to our SMS program, we use your phone number
            exclusively to send you the messages you requested, such as order
            updates or promotional alerts. We respect your privacy and strictly
            protect your phone number from unauthorized sharing.
          </p>
        </section>

        <section data-id="element-319">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-320">
            Data Retention
          </h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-321">
            We store the information we collect about you for as long as is
            necessary for the purpose(s) for which we originally collected it.
            We may retain certain information for legitimate business purposes
            or as required by law.
          </p>
        </section>

        <section data-id="element-322">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-323">Your Rights</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-324">
            You have the right to access, correct, or delete your personal
            information. You may also opt out of receiving promotional
            communications from us at any time. To opt out of SMS
            communications, reply STOP to any message you receive from us.
          </p>
        </section>

        <section data-id="element-325">
          <h2 className="text-2xl font-medium text-white mb-4" data-id="element-326">Contact</h2>
          <p className="text-neutral-300 leading-relaxed" data-id="element-327">
            If you have any questions about this Privacy Policy, please contact
            us at:
            <br data-id="element-328" />
            <br data-id="element-329" />
            VSCCLOTHING d/b/a VSC Clothing
            <br data-id="element-330" />
            312 S 4th Street Downtown
            <br data-id="element-331" />
            Louisville, KY 40202
            <br data-id="element-332" />
            <a href="mailto:vscclothing5@gmail.com" className="underline hover:text-white" data-id="element-333">
              vscclothing5@gmail.com
            </a>
          </p>
        </section>
      </div>
    </div>;
}